export const simpleObjectCopy = (obj) => {
  return JSON.parse(JSON.stringify(obj))
}
